import slackLogo from "../../assets/image/_x33_06-slack.png"
import ciscoLogo from "../../assets/image/cisco 1.png"

const environmentLogin = {
  slack: {
    redirect_uri: process.env.REACT_APP_SLACK_REDIRECT_URI,
    scope_auth: process.env.REACT_APP_SLACK_SCOPE_AUTH,
    client_id: process.env.REACT_APP_SLACK_CLIENT_ID,
    scope_install: process.env.REACT_APP_SLACK_SCOPE_INSTALL
  },
  cisco: {
    client_id: process.env.REACT_APP_WEBEX_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_WEBEX_REDIRECT_URI
  }
}
export const appLoginDatas: AppLoginDataTypes[] = [
  {
    image: slackLogo,
    title: "Slack",
    loginUrl: `https://slack.com/oauth/v2/authorize?user_scope=${environmentLogin.slack.scope_auth}&client_id=${environmentLogin.slack.client_id}&redirect_uri=${environmentLogin.slack.redirect_uri}&state=authv2`,
    installUrl: `https://slack.com/oauth/v2/authorize?scope=${environmentLogin.slack.scope_install}&client_id=${environmentLogin.slack.client_id}&redirect_uri=${environmentLogin.slack.redirect_uri}&state=installv2`,
    description: ""
  },
  {
    image: ciscoLogo,
    title: "Cisco Webex",
    loginUrl: `https://webexapis.com/v1/authorize?client_id=${environmentLogin.cisco.client_id}&response_type=code&redirect_uri=${environmentLogin.cisco.redirect_uri}&scope=spark%3Amemberships_read%20spark%3Akms%20spark%3Arooms_read%20spark%3Apeople_read%20spark%3Amessages_write%20spark%3Ateams_read%20spark%3Arooms_write%20spark%3Amessages_read&state=webex_login`,
    installUrl: `https://apphub.webex.com/applications/standup-alice-standup-alice-44732`,
    description:
      "Or send<strong>&nbsp;@StandupAlice Status&nbsp;</strong>in a channel"
  }
]
